import { FRONTEND_PROPERTY_NAME } from '../../common/constants.js';
export function validateGroups(node, nodeFields, accept) {
    const { idField, groupNameField, groupOrderField } = nodeFields;
    // If a groupName is provided, then we should also have groupOrder
    let groupNameProvided = false;
    let groupOrderProvided = false;
    if (groupNameField && groupNameField.groupName.$type === 'StringField') {
        groupNameProvided = true;
    }
    if (groupOrderField && groupOrderField.groupOrder.$type === 'NumbersField') {
        groupOrderProvided = true;
    }
    if (groupNameProvided && !groupOrderProvided) {
        accept('error', `Missing required 'groupOrder' field for node '${node?.name}'.`, {
            node,
            data: {
                id: idField?.id?.value,
                nodeNumber: node?.name,
                propertyName: FRONTEND_PROPERTY_NAME.GROUP_ORDER,
            },
        });
    }
    if (!groupNameProvided && groupOrderProvided) {
        accept('error', `Missing required 'groupName' field for node '${node?.name}'.`, {
            node,
            data: {
                id: idField?.id?.value,
                nodeNumber: node?.name,
                propertyName: FRONTEND_PROPERTY_NAME.GROUP_NAME,
            },
        });
    }
}
//# sourceMappingURL=validate-groups.js.map